import { InteractiveMapLocation } from "@redotech/redo-common-model-location-common/interactive-map-location";
import { areAllLocationsOutsideConfiguredRadius } from "@redotech/redo-customer-portal-shared/hooks/useShipmentMethod/dropoff-proximity";
import { useTranslation } from "@redotech/redo-i18n";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const LocationOutsideRadiusWarning = memo(
  function LocationOutsideRadiusWarning({
    location,
  }: {
    location: InteractiveMapLocation;
  }) {
    const { t } = useTranslation();

    if (!location.outsideConfiguredRadius) {
      return null;
    }

    const radiusMiles = location.configuredRadiusMiles;
    const message =
      radiusMiles != null
        ? t(
            "This location is outside your team's {{radiusMiles}}-mile return radius.",
            { radiusMiles },
          )
        : t("This location is outside your team's configured return radius.");

    return (
      <Text fontSize="xs" textColor="warning">
        {message}
      </Text>
    );
  },
);

export const InStoreOutsideRadiusNotice = memo(
  function InStoreOutsideRadiusNotice({
    locations,
  }: {
    locations: InteractiveMapLocation[];
  }) {
    const { t } = useTranslation();
    if (!areAllLocationsOutsideConfiguredRadius(locations)) {
      return null;
    }

    const radiusMiles = locations.find(
      (location) => location.configuredRadiusMiles != null,
    )?.configuredRadiusMiles;
    const message =
      radiusMiles != null
        ? t(
            "No store is within {{radius}} miles of this customer's address. You can still choose in-store drop-off.",
            { radius: radiusMiles },
          )
        : t(
            "No store is within the configured radius of this customer's address. You can still choose in-store drop-off.",
          );

    return (
      <Text fontSize="xs" textColor="warning">
        {message}
      </Text>
    );
  },
);
